import { FC } from "react";
import { Flex, Text } from "@smile2impress/components/relaunch";

import { AdvantageProps } from "./Advantage.types";

export const Advantage: FC<AdvantageProps> = ({ title, subtitle }) => {
    return (
        <Flex direction="column" gap="8px">
            <Text textStyle={["H2"]} color={["text.baseInverse"]}>
                {title}
            </Text>
            <Text
                textStyle={["H3"]}
                color={["text.baseInverse"]}
                textTransform="uppercase"
            >
                {subtitle}
            </Text>
        </Flex>
    );
};
